export const FLAG_GETTING_DEPARTAMENTS = 'FLAG_GETTING_DEPARTAMENTS';
export const GET_DEPARTAMENTS = 'GET_DEPARTAMENTS';
export const CLEAR_FDEPARTAMENTS = 'CLEAR_FDEPARTAMENTS';
export const FLAG_GETTING_AREAS = 'FLAG_GETTING_AREAS';
export const GET_AREAS = 'GET_AREAS';
export const CLEAR_AREAS = 'CLEAR_AREAS';
